export default __webpack_public_path__ + "static/media/kyc.f80499cc.svg";